import React, { useEffect, useRef } from "react";

import { ArrowLeftIcon } from "@heroicons/react/24/outline";

import ThreadMessages from "./ThreadMessages.jsx";
import ThreadSendMessage from "../../components/ThreadSendMessage";

const Thread = ({
  selectedThread,
  setSelectedThread,
  messages,
  fetchThread,
  chatbotUuid,
  api,
}) => {
  const messageEndRef = useRef(null);

  const scrollToBottom = () => {
    if (messageEndRef.current) {
      messageEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  return (
    <div
      className={`flex-grow h-full p-4
        ${!selectedThread && "hidden sm:flex"}`}
    >

      {selectedThread ? (
        <div className="flex flex-col h-full">
          <div className="flex-1 p-0">
            <h2 className="text-lg font-bold hidden">{selectedThread.title}</h2>
            <div className="mt-0">
              <ThreadMessages thread={selectedThread} messages={messages} />
            </div>
            <div ref={messageEndRef} />
          </div>

          <div className="sticky bottom-0 bg-white pb-4 z-10 shadow-sm">
            <ThreadSendMessage
              chatbotUuid={chatbotUuid}
              selectedThread={selectedThread}
              api={api}
              fetchThread={fetchThread}
            />
          </div>
        </div>
      ) : (
        <div className="text-gray-500" />
      )}
    </div>
  );
};

export default Thread;
